<template>
	<post-smtp-widget class="gmail-wrapper">
		<div class="gmail-one-click-banner">
			<div class="gmail-one-click-banner__visual">
				<post-smtp-img
					class="gmail-one-click-banner__gif"
					:src="plugin_dir_url + 'assets/images/gmail_one_click.gif'"
					:alt="i18n.gifAlt"
				/>
			</div>

			<div class="gmail-one-click-banner__body">
				<div class="gmail-one-click-banner__header">
					<div class="gmail-one-click-banner__unlock-row">
						<p class="gmail-one-click-banner__unlock">{{ i18n.unlock }}</p>
						<span class="gmail-one-click-banner__badge">
							<post-smtp-img
								class="gmail-one-click-banner__badge-icon"
								:src="plugin_dir_url + 'assets/images/gmail-pro-crown.svg'"
								:alt="i18n.badge"
							/>
							<span class="gmail-one-click-banner__badge-text">{{ i18n.badge }}</span>
						</span>
					</div>
					<h3 class="gmail-one-click-banner__title">{{ i18n.title }}</h3>
				</div>

				<p class="gmail-one-click-banner__description">{{ i18n.description }}</p>

				<ul class="gmail-one-click-banner__benefits">
					<li v-for="( benefit, index ) in i18n.benefits" :key="index">
						<post-smtp-img
							class="gmail-one-click-banner__check"
							:src="plugin_dir_url + 'assets/images/gmail-banner-check.png'"
							alt=""
						/>
						<span>{{ benefit }}</span>
					</li>
				</ul>

				<a
					class="gmail-one-click-banner__cta"
					:href="pricingUrl"
					target="_blank"
					rel="noopener noreferrer"
				>
					<svg class="gmail-one-click-banner__cta-icon" width="20" height="20" viewBox="0 0 16 16" fill="none" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
						<path d="M9.33333 1.33334L4 9.33334H8L6.66667 14.6667L12 6.66667H8L9.33333 1.33334Z" fill="currentColor"/>
					</svg>
					{{ i18n.button }}
				</a>
			</div>
		</div>
	</post-smtp-widget>
</template>

<script>
export default {
	name: 'PostSmtpGmailOneClickBanner',

	data: ( vm ) => ( {
		plugin_dir_url: vm.$parent.plugin_dir_url,
		i18n: postSmtpNewDashboard.i18n.sidebar.gmailOneClick,
		pricingUrl: 'https://postmansmtp.com/pricing/?utm_source=plugin&utm_medium=dashboard&utm_campaign=gmail_one_click',
	} ),
};
</script>

<style scoped>
.gmail-one-click-banner {
	overflow: hidden;
	border: 1px solid #dce3f0;
	border-radius: 12px;
	background: #ffffff;
	box-shadow: 0 2px 8px rgba( 35, 31, 32, 0.06 );
}

.gmail-one-click-banner__visual {
	padding: 12px 12px 0;
	background: #ffffff;
}

.gmail-one-click-banner__gif {
	display: block;
	width: 100%;
	height: auto;
	border-radius: 8px 8px 0 0;
}

.gmail-one-click-banner__body {
	display: flex;
	flex-direction: column;
	gap: 10px;
	padding: 16px 16px 18px;
}

.gmail-one-click-banner__header {
	display: flex;
	flex-direction: column;
	gap: 2px;
}

.gmail-one-click-banner__unlock-row {
	display: flex;
	align-items: center;
	justify-content: space-between;
	width: 100%;
}

.gmail-one-click-banner__unlock {
	margin: 0;
	font-family: Poppins, system-ui, sans-serif;
	font-size: 10px;
	font-weight: 700;
	line-height: 1.2;
	color: #375caf;
}

.gmail-one-click-banner__title {
	margin: 0;
	font-family: Poppins, system-ui, sans-serif;
	font-size: 15px;
	font-weight: 700;
	line-height: 1.25;
	color: #375caf;
}

.gmail-one-click-banner__badge {
	flex-shrink: 0;
	box-sizing: border-box;
	display: inline-flex;
	flex-direction: row;
	align-items: center;
	gap: 3.04px;
	height: 15.94px;
	padding: 3.79px;
	border-radius: 3.04px;
	background-color: #eae6ff;
	background-image: linear-gradient( 98.77deg, #214a72 -14.75%, #3a5eaf 98.73% );
}

.gmail-one-click-banner__badge-icon {
	display: block;
	width: auto;
	height: 8px;
}

.gmail-one-click-banner__badge-text {
	font-family: Poppins, system-ui, sans-serif;
	font-size: 8px;
	font-weight: 700;
	line-height: 1;
	letter-spacing: 0.06em;
	color: #ffd114;
}

.gmail-one-click-banner__description {
	margin: 0;
	font-family: Poppins, system-ui, sans-serif;
	font-size: 12px;
	font-weight: 500;
	line-height: 1.45;
	color: #464646;
}

.gmail-one-click-banner__benefits {
	margin: 2px 0 4px;
	padding: 0;
	list-style: none;
	display: flex;
	flex-direction: column;
	gap: 7px;
}

.gmail-one-click-banner__benefits li {
	display: flex;
	align-items: flex-start;
	gap: 8px;
	font-family: Poppins, system-ui, sans-serif;
	font-size: 11px;
	font-weight: 500;
	line-height: 1.35;
	color: #231f20;
}

.gmail-one-click-banner__check {
	flex-shrink: 0;
	width: 12px;
	height: 12px;
	margin-top: 1px;
}

.gmail-one-click-banner__cta {
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 8px;
	width: 85%;
	margin: 0 auto;
	padding: 12px 16px;
	border-radius: 8px;
	background: #3a5eaf;
	color: #ffffff;
	font-family: Poppins, system-ui, sans-serif;
	font-size: 14px;
	font-weight: 600;
	line-height: 1.2;
	text-decoration: none;
	transition: background 0.15s ease, transform 0.15s ease;
}

.gmail-one-click-banner__cta:hover,
.gmail-one-click-banner__cta:focus {
	background: #2f4f98;
	color: #ffffff;
	text-decoration: none;
	box-shadow: none;
	transform: translateY( -1px );
}

.gmail-one-click-banner__cta-icon {
	flex-shrink: 0;
	width: 20px;
	height: 20px;
}
</style>
